import { render, staticRenderFns } from "./Strikethrough.vue?vue&type=template&id=18036c7e"
import script from "./Strikethrough.vue?vue&type=script&lang=js"
export * from "./Strikethrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports